import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Moon, Sun } from "lucide-react";

export function usePortalTheme() {
  const [mode, setMode] = useState(() => {
    try { return localStorage.getItem("cevre-portal-theme") === "night" ? "night" : "day"; }
    catch { return "day"; }
  });
  useEffect(() => { document.documentElement.dataset.cevreTheme = mode; }, [mode]);
  const toggle = () => setMode((current) => {
    const next = current === "day" ? "night" : "day";
    try { localStorage.setItem("cevre-portal-theme", next); } catch { /* Private storage may be unavailable. */ }
    return next;
  });
  return { mode, toggle };
}

export function PortalThemeButton({ mode, toggle }) {
  const night = mode === "night";
  const Icon = night ? Sun : Moon;
  const label = night ? "Gündüz modu" : "Gece modu";
  return <Button type="button" variant="outline" size="sm" onClick={toggle}
    aria-label={label} title={label} aria-pressed={night} data-testid="portal-theme-toggle">
    <Icon className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">{label}</span>
  </Button>;
}
